import { Link } from "react-router-dom";
import { Monitor, MonitorGroup } from "../types";

interface MonitorCardProps {
  monitor: Monitor;
  group?: MonitorGroup | null;
  lastP95?: number | null;
  uptimePct?: number;
  onDelete?: () => void;
  onRemoveFromGroup?: () => void;
  linkState?: Record<string, unknown>;
}

export default function MonitorCard({ monitor, group, lastP95, uptimePct, onDelete, onRemoveFromGroup, linkState }: MonitorCardProps) {
  const statusColor =
    uptimePct == null      ? "#98A1AB"
    : uptimePct >= 99      ? "#39D98A"
    : uptimePct >= 95      ? "#FDDD48"
    : "#FF5C5C";

  return (
    <div
      className="glass"
      style={{ padding: "16px 20px", display: "flex", flexDirection: "column", gap: 8 }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <Link
            to={`/dashboard/monitors/${monitor.id}`}
            state={linkState}
            style={{ color: "#EFF2F5", fontWeight: 600, fontSize: 15, textDecoration: "none" }}
          >
            {monitor.name}
          </Link>
          <p style={{ margin: "2px 0 0", fontSize: 12, color: "#98A1AB" }}>
            {monitor.url.replace(/^tcp:\/\//, "")}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{
            width: 8, height: 8, borderRadius: "50%",
            background: monitor.is_active ? statusColor : "rgba(152,161,171,0.25)",
            display: "inline-block",
          }} />
          {onRemoveFromGroup && (
            <button
              onClick={onRemoveFromGroup}
              style={{ background: "none", border: "1px solid rgba(255,255,255,0.1)", cursor: "pointer", color: "#98A1AB", fontSize: 12, padding: "2px 8px", lineHeight: 1, borderRadius: 3 }}
              title="Remove from group"
            >
              Remove
            </button>
          )}
          {onDelete && (
            <button
              onClick={onDelete}
              style={{ background: "none", border: "none", cursor: "pointer", color: "#98A1AB", fontSize: 18, padding: "0 4px", lineHeight: 1 }}
              title="Delete monitor"
            >
              ×
            </button>
          )}
        </div>
      </div>

      <div style={{ display: "flex", gap: 16, fontSize: 12, flexWrap: "wrap", alignItems: "center" }}>
        <span style={{ color: "#98A1AB" }}>Every {monitor.interval_minutes}m</span>
        <span style={{
          fontSize: 11, fontWeight: 700, color: monitor.method === "TCP" ? "#29B6F6" : "#98A1AB",
          background: monitor.method === "TCP" ? "rgba(41,182,246,0.1)" : "transparent",
          padding: monitor.method === "TCP" ? "1px 5px" : undefined, borderRadius: 2,
        }}>
          {monitor.method === "TCP" ? "TCP" : monitor.method}
        </span>
        {lastP95 != null && (
          <span style={{ color: "#98A1AB" }}>
            P95: <strong style={{ color: "#EFF2F5" }}>{lastP95}ms</strong>
          </span>
        )}
        {uptimePct != null && (
          <span style={{ color: statusColor, fontWeight: 600 }}>
            {uptimePct.toFixed(1)}% uptime
          </span>
        )}
        {group && (
          <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <span style={{ width: 8, height: 8, borderRadius: 2, background: group.color, display: "inline-block", flexShrink: 0 }} />
            <span style={{ color: "#98A1AB" }}>{group.name}</span>
          </span>
        )}
      </div>
    </div>
  );
}
